export default __webpack_public_path__ + "static/media/game_over.6018ba27.gif";